<template>
  <div class="shop-sticker-container" @click="reconnectConciergerie">
    <Tooltip style="width: fit-content;" :active="disabled || !isConciergerie" :text="!isConciergerie ? $t('dash.bots.status_proxy') : $t('dash.post.error.need_video.title')" position="top">
      <vs-button
        type="border"
        color="rgba(0, 0, 0, 0.2)"
        class="shop-btn"
        icon="local_mall"
        @click="() => {tagUse ? $emit('click') : addShop()}"
        :disabled="disabled || !isConciergerie"
        >{{ tagUse ? $t('dash.post.btn.tag_shop') : $t('dash.post.btn.add_shop') }}</vs-button
      >
    </Tooltip>
    <div :ref="tagUse ? 'searchTagImgShop': ''" :style="(tagUse && 'z-index: 10000000; position: fixed;' + (tagUse === 'video' && 'top: 50%; left: 50%;'))">
      <div :style="tagUse && 'z-index: 10000000;'" class="auto-mentions row box" v-if="shopIsOpen">
        <div class="search-box-shop">
          <vs-button v-if="step !== 'shop'"
            class="page-btn back-btn"
            vs-type="filled"
            color="#6a1f4c"
            icon="arrow_back"
            @click.prevent="backShop"
            ></vs-button
          >
          <vs-input
            color="#B20564"
            type="text"
            name="search-mention"
            class="inputx"
            :placeholder="step === 'shop' ? 'Rechercher un magasin' : 'Rechercher un produit'"
            v-model="searchedShop"
            v-on:keyup="() => step === 'shop' ? searchShop() : searchProduct()"
            v-on:click="() => step === 'shop' ? searchShop() : searchProduct()"
            ref="inputSearchShop"
            autocomplete="off"
            v-on:keydown.enter.prevent
          />
          <vs-button
            class="page-btn ok-btn"
            vs-type="filled"
            color="#6a1f4c"
            @click.prevent="insertShop"
            >OK</vs-button
          >
        </div>
        <p v-if="!tagUse" :class="`product-count ${selectedProducts.length === 5 && 'full'}`">{{selectedProducts.length}}/5</p>
        <div v-if="step === 'shop'" id="loading-shop" class="vs-con-loading__container shops-list">
          <p v-if="shopsList.length === 0">{{$t("dash.no-result.title")}}</p>
          <div :class="`shop-item ${selectedProducts.map(e => e.id).includes(shop.id)  && 'selected'}`" v-for="shop of shopsList"
            :key="shop.id" @click="() => selectShop(shop.id)">
            <img :src="shop.image" alt="logo"/>
            <p>{{shop.text}}</p>
          </div>
        </div>
        <div v-else-if="step === 'items'" id="loading-items" class="vs-con-loading__container items-list">
          <p v-if="itemsList.length === 0">{{$t("dash.no-result.title")}}</p>
          <div :class="`items-item ${(selectedProducts.map(e => e.id).includes(item.id) || selectedProducts.map(e => e.product).includes(item.id)) && 'selected'}`" v-for="item of itemsList"
            :key="item.id" @click="() => item.variant ? colorsProduct(item.id) : selectProduct(item)">
            <img :src="item.image" alt="logo"/>
            <div class="items-infos">
              <p class="name">{{item.text}}</p>
              <p class="description">{{item.description}}</p>
            </div>
          </div>
        </div>
        <div v-else-if="step === 'colors'" id="loading-color" class="vs-con-loading__container shops-list">
          <div :class="`shop-item ${selectedProducts.map(e => e.id).includes(color.id)  && 'selected'}`" v-for="color of colorsList"
            :key="color.id" @click="() => selectProduct(color)">
            <img :src="color.image" alt="logo"/>
            <p>{{color.number}}</p>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Posts from '../mixins/Posts'
import Notif from '../mixins/Notif'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  mixins: [Posts, Notif],

  props: {
    pageId: String,
    disabled: Boolean,
    isConciergerie: Boolean,
    products: Array,
    tagUse: {
      type: String,
      default: null
    }
  },

  components: {
    Tooltip
  },

  mounted() {
    this.selectedProducts = this.products;
  },

  watch: {

    products(newVal, oldVal) {
      if (!oldVal || (oldVal.every(e => !e.image) && newVal.every(e => e.image))) {
        this.selectedProducts = newVal;
      }
    }

  },

  data() {
    return {
      shopIsOpen: false,
      shopsList: [],
      itemsList: [],
      colorsList: [],
      searchedShop: '',
      selectedProducts: [],
      shopId: null,
      step: 'shop'
    }
  },

  computed: {},

  methods: {

    reconnectConciergerie() {
      if (!this.isConciergerie) {
        this.$emit("reconnect");
      }
    },

    backShop() {
      if (this.step === 'colors') {
        this.step = 'items';
      } else if (this.step === 'items') {
        this.searchedShop = '';
        this.step = 'shop'
      }
    },

    async selectShop(shopId) {
      this.shopId = shopId;
      this.searchedShop = '';
      console.log('selectShop')
      this.step = "items";
      this.$nextTick(() => {
        document.getElementsByClassName('shop-btn')[0].classList.remove('isActive')
        this.$vs.loading({container: '#loading-items',scale: 0.6})
        this.getTrendItemsShopInstagram(this.pageId, this.shopId).then((result) => {
          //Ajouter la listes des shop dans shopsList
          console.log('SHOP:', result)
          if (
              result.ok &&
              result.body &&
              result.body.success &&
              result.body.items
          ) {
              this.itemsList = result.body.items;
          } else {
              this.notify({
              title: 'Erreur',
              text: this.$t(result.body.error),
              color: 'danger',
              time: 10000,
              id: this.pageId
              })
          }
          this.$vs.loading.close('#loading-items > .con-vs-loading')
        })
      })
    },

    async addShop() {
      console.log('addShop')
      this.step = "shop";
      this.shopIsOpen = true
      this.$nextTick(() => {
        document.getElementsByClassName('shop-btn')[0].classList.remove('isActive')
        this.$vs.loading({container: '#loading-shop',scale: 0.6})
        this.getTrendShopsInstagram(this.pageId).then((result) => {
          //Ajouter la listes des shop dans shopsList
          console.log('SHOP:', result)
          if (
            result.ok &&
            result.body &&
            result.body.success &&
            result.body.shops
          ) {
            this.shopsList = result.body.shops;
          } else {
            this.notify({
              title: 'Erreur',
              text: this.$t(result.body.error),
              color: 'danger',
              time: 10000,
              id: this.pageId
            })
          }
          this.$vs.loading.close('#loading-shop > .con-vs-loading')
        })
      })
    },

    selectProduct(product) {
      console.log("selectProduct", product, this.tagUse);
      
      if (this.tagUse && this.tagUse === 'image') {
        if (!this.selectedProducts.map(e => e.id).includes(product.id)) {
          product.merchantId = this.shopId;
          this.$emit('insertShop', product);
          this.shopIsOpen = false;
        }
        return;
      }
      console.log('product selected : ', product)
      if (this.selectedProducts.length < 5) {
        if (this.selectedProducts.map(e => e.id).includes(product.id)) {
          this.selectedProducts = this.selectedProducts.filter(e => e.id !== product.id);
        } else {
          product.merchantId = this.shopId
          this.selectedProducts.push(product)
        }
      }
      
    },

    insertShop() {
      console.log('shop selected : ', this.selectedProducts)
      this.shopIsOpen = false
      if (this.selectedProducts && this.selectedProducts.length) {
        this.$emit('insertShop', this.selectedProducts)
      }
    },

    searchShop() {
      console.log('search:', this.searchedShop)
      if (this.searchedShop.length > 0) {
        let search = this.searchedShop.repeat(1)
        setTimeout(() => {
          if (this.searchedShop === search) {
            this.$vs.loading({
              container: '#loading-shop',
              scale: 0.6
            })
            this.searchShopsInstagram(this.pageId, this.searchedShop).then((result) => {
              console.log(result)
              if (
                result.ok &&
                result.body &&
                result.body.success &&
                result.body.shops
              ) {
                this.shopsList = result.body.shops;
              } else {
                this.notify({
                  title: 'Erreur',
                  text: this.$t(result.body.error),
                  color: 'danger',
                  time: 10000,
                  id: this.pageId
                })
              }
              this.$vs.loading.close('#loading-shop > .con-vs-loading')
            })
          }
        }, 800)
      }
      //Attendre au moins 3 char avant d'envoyer une requete
    },

    searchProduct() {
      console.log('search:', this.searchedShop)
      if (this.searchedShop.length > 0) {
        let search = this.searchedShop.repeat(1)
        setTimeout(() => {
          if (this.searchedShop === search) {
            this.$vs.loading({
              container: '#loading-items',
              scale: 0.6
            })
            this.searchItemsShopInstagram(this.pageId, this.shopId ,this.searchedShop).then((result) => {
              console.log(result)
              if (
                  result.ok &&
                  result.body &&
                  result.body.success &&
                  result.body.items
              ) {
                this.itemsList = result.body.items;
              } else {
                this.notify({
                  title: 'Erreur',
                  text: this.$t(result.body.error),
                  color: 'danger',
                  time: 10000,
                  id: this.pageId
                })
              }
              this.$vs.loading.close('#loading-items > .con-vs-loading')
            })
          }
        }, 800)
      }
      //Attendre au moins 3 char avant d'envoyer une requete
    },

    async colorsProduct(productId) {
      console.log('colorsProduct')
      this.step = "colors";
      this.shopIsOpen = true
      let merchantId = this.shopId; 
      this.$nextTick(() => {
        document.getElementsByClassName('shop-btn')[0].classList.remove('isActive')
        this.$vs.loading({container: '#loading-color',scale: 0.6})
        this.chooseItemShopInstagram(this.pageId, productId, merchantId).then((result) => {
          //Ajouter la listes des shop dans shopsList
          console.log('COLORS:', result)
          if (
            result.ok &&
            result.body &&
            result.body.success &&
            result.body.items
          ) {
            this.colorsList = result.body.items;
          } else {
            this.notify({
              title: 'Erreur',
              text: this.$t(result.body.error),
              color: 'danger',
              time: 10000,
              id: this.pageId
            })
          }
          this.$vs.loading.close('#loading-color > .con-vs-loading')
        })
      })
    },
  }
}
</script>

<style>
</style>